import React, { useContext, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchAnthropometryWithFilters } from '../../../redux/actions/anthropometryActions';
import { fetchPatients, fetchAllProfessionals } from '../../../redux/actions/relatedEntitiesActions';
import { fetchPersons } from '../../../redux/actions/personActions';
import { clearAnthropometry } from '../../../redux/slices/anthropometrySlice';
import Select from 'react-select';
import Pagination from '../../../components/Pagination/Pagination';
import { AuthContext } from '../../../context/auth';
import SearchBar from '../../../components/SearchBar/SearchBar';

import { FaUserDoctor } from "react-icons/fa6";
import { MdOutlineSick } from "react-icons/md";
import { LuCalendarClock } from "react-icons/lu";
import { BiBody } from "react-icons/bi";
import { MdHome } from 'react-icons/md';

import babyComming from "../../../assets/img/cegonha.png";
import AnthropometryDetails from '../components/AnthropometryDetails';

import '../styles/GetAnthropometry.css';
import '../../../styles/ReactSelect.css';
import '../../../Mobile.css';

import {
  formatDate,
  formatGender,
  calculateAge,
  formatPhysicalActivityLevel,
  formatPhysicalActivityFrequency,
} from '../../../utils/Functions/formatPersons';
import {
  formatedClassificatoinBlackburn, formatedClassificationBMI, formatedClassificationBray,
  formatedClassificationBernadinelli, formatedClassificationInternalFat, formatedClassificationWaistCircumference,
  formatedClassificationMuscleMass, formatedClassificationLeanMass, formatedClassificationLeanWeightType,

} from '../../../utils/Functions/formatAnthropometry';


function GetAnthropometryWithFilters() {
  const { loginUser } = useContext(AuthContext);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const returnBtn = "Retornar";

  // States
  const [searchText, setSearchText] = useState("");
  const [filterType, setFilterType] = useState('all'); // 'all', 'patient', 'professional', 'date'
  const [filters, setFilters] = useState({
    patientId: null,
    nutritionistId: null,
    startDate: '',
    endDate: ''
  });
  // Adicione um estado para mensagens
  const [filterMessage, setFilterMessage] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // Get data from store
  const { patients = [], loadingPatients } = useSelector((state) => state.relatedEntities);
  const { professionals = [], loadingProfessionals } = useSelector((state) => state.relatedEntities);
  const { persons = [], loadingPersons } = useSelector((state) => state.persons);
  const { currentAnthropometry = [], loadingAnthropometry, errorAnthropometry } = useSelector((state) => state.anthropometry || { currentAnthropometry: [] });

  // Professional name mapping
  const [loadedProfessionals, setLoadedProfessionals] = useState({});
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [selectedNutritionist, setSelectedNutritionist] = useState(null);
  const [filteredData, setFilteredData] = useState([]);

  // Load initial data
  useEffect(() => {
    dispatch(fetchPatients());
    dispatch(fetchPersons());
    dispatch(fetchAllProfessionals());
    fetchAllData();
  }, [dispatch]);

  // Map professionals data
  useEffect(() => {
    if (!loadingPersons && !loadingProfessionals && persons.length > 0 && professionals.length > 0) {
      const professionalMap = {};
      persons.forEach(person => {
        if (['nutritionist', 'professional', 'doctor'].includes(person.person_type)) {
          professionalMap[person.person_id] = `${person.first_name} ${person.last_name}`;
        }
      });
      professionals.forEach(professional => {
        if (!professionalMap[professional.person_id]) {
          professionalMap[professional.person_id] = professional.name || 'Nome não disponível';
        }
      });
      setLoadedProfessionals(professionalMap);
    }
  }, [loadingPersons, loadingProfessionals, persons, professionals]);


  // Handle search
  const handleSearch = (text) => {
    setSearchText(text);
    if (text === "") {
      setFilteredData(currentAnthropometry);
    } else {
      const filtered = currentAnthropometry.filter(item => {
        const patient = persons.find(p => p.person_id === item.patient_id);
        const patientName = patient ? `${patient.first_name} ${patient.last_name}` : '';
        const professionalName = loadedProfessionals[item.nutritionist_id] || '';

        return `${patientName} ${professionalName} ${formatDate(item.measurement_date)}`
          .toLowerCase()
          .includes(text.toLowerCase());
      });
      setFilteredData(filtered);
    }
  };

  // Fetch all data
  const fetchAllData = () => {
    dispatch(clearAnthropometry());
    dispatch(fetchAnthropometryWithFilters({}));
    setCurrentPage(1);
  };

  // Apply filters
  const applyFilters = () => {
    // Verificação de filtros válidos

    setFilterMessage('');

    if (filterType === 'patient' && !filters.patientId) {
      console.warn('Nenhum paciente selecionado');
      setFilterMessage('Selecione um paciente');
      return;
    }

    if (filterType === 'professional' && !filters.nutritionistId) {
      console.warn('Nenhum nutricionista selecionado');
      setFilterMessage('Selecione um nutricionista');
      return;
    }

    if (filterType === 'date' && !filters.startDate && !filters.endDate) {
      console.warn('Nenhuma data selecionada');
      setFilterMessage('Selecione pelo menos uma data');
      return;
    }

    dispatch(clearAnthropometry());

    const backendFilters = {};

    // Mapeamento consistente
    if (filters.patientId) backendFilters.patient_id = filters.patientId;
    if (filters.nutritionistId) backendFilters.nutritionist_id = filters.nutritionistId;
    if (filters.startDate) backendFilters.start_date = filters.startDate;
    if (filters.endDate) backendFilters.end_date = filters.endDate;
    console.log('[FRONT] Filtros enviados:', backendFilters);

    dispatch(fetchAnthropometryWithFilters(backendFilters));
    setCurrentPage(1);
  };

  useEffect(() => {
    if (filterMessage) {
      const timer = setTimeout(() => {
        setFilterMessage('');
      }, 2000); // Remove a mensagem após 5 segundos

      return () => clearTimeout(timer);
    }
  }, [filterMessage]);

  const handleFilterTypeChange = (type) => {
    setFilterType(type);
    if (type === 'all') {
      fetchAllData();
      setFilterMessage('');
    }
  };

  // Handle patient selection
  const handlePatientChange = (selectedOption) => {
    setSelectedPatient(selectedOption);
    setFilters(prev => ({
      ...prev,
      patientId: selectedOption?.value || null
    }));
  };

  // Handle nutritionist selection
  const handleNutritionistChange = (selectedOption) => {
    setSelectedNutritionist(selectedOption);
    setFilters(prev => ({
      ...prev,
      nutritionistId: selectedOption?.value || null
    }));
  };

  // Handle date changes
  const handleDateChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Find Patient name by ID
  const findPatientName = (patient_id) => {
    const p = persons.find(p => p.person_id === patient_id);
    return p ? `${p.first_name} ${p.last_name}` : 'Paciente não encontrado';
  };

  // Find nutritionist name by ID
  const findNutritionistName = (nutritionist_id) => {
    if (!nutritionist_id) return 'ID do nutricionista não fornecido';
    return loadedProfessionals[nutritionist_id] || 'Nutricionista não encontrado';
  };

  if (loadingPersons) {
    return <div>Carregando pacientes...</div>;
  }

  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = searchText ? filteredData.slice(indexOfFirstItem, indexOfLastItem) : currentAnthropometry.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <>
      <h3>Buscar Medições Antropométricas</h3>

      {/* Search Bar */}
      <div className="col-md-12">
        <SearchBar onSearch={handleSearch} />
      </div>

      {/* Filter Controls */}
      <div className="filterControls">
        <div className="filterRadioGroup">
          <label className='labelRadioGroup'>
            <input
              type="radio"
              name="filterType"
              checked={filterType === 'all'}
              onChange={() => handleFilterTypeChange('all')}
            />
            <span className='radioSpan'>Todos</span>
          </label>

          <label className='labelRadioGroup'>
            <input
              type="radio"
              name="filterType"
              checked={filterType === 'patient'}
              onChange={() => handleFilterTypeChange('patient')}
            />
            <span className='radioSpan'>Por Paciente</span>
          </label>

          <label className='labelRadioGroup'>
            <input
              type="radio"
              name="filterType"
              checked={filterType === 'professional'}
              onChange={() => handleFilterTypeChange('professional')}
            />
            <span className='radioSpan'>Por Profissional</span>
          </label>

          <label className='labelRadioGroup'>
            <input
              type="radio"
              name="filterType"
              checked={filterType === 'date'}
              onChange={() => handleFilterTypeChange('date')}
            />
            <span className='radioSpan'>Por Data</span>
          </label>
        </div>
      </div>

      {/* Filter Form */}
      <div className="radio_filters">
        {filterType === 'patient' && (
          <div className="getAnthropometry-form-group">
            <label className='labelRadio'>Paciente:</label>
            <Select
              options={persons
                .filter(person => person.person_type === 'patient')
                .map(patient => ({
                  value: patient.person_id,
                  label: `${patient.first_name} ${patient.last_name}`,
                }))}
              classNamePrefix="custom-select"
              onChange={handlePatientChange}
              value={selectedPatient}
              placeholder="Selecione o paciente"
              isLoading={loadingPatients}
              isClearable
            />
          </div>
        )}

        {filterType === 'professional' && (
          <div className="getAnthropometry-form-group">
            <label className='labelRadio'>Nutricionista:</label>
            <Select
              options={Object.entries(loadedProfessionals).map(([id, name]) => ({
                value: id,
                label: name,
              }))}
              classNamePrefix="custom-select"
              onChange={handleNutritionistChange}
              value={selectedNutritionist}
              placeholder="Selecione o nutricionista"
              isLoading={loadingProfessionals}
              isClearable
            />
          </div>
        )}

        {filterType === 'date' && (
          <>
            <div className="">
              <label className='labelRadio'>Data Inicial:</label>
              <input
                type="date"
                name="startDate"
                className='filters_date'
                value={filters.startDate}
                onChange={handleDateChange}

              />
            </div>
            <div className="">
              <label className='labelRadio'>Data Final:</label>
              <input
                type="date"
                name="endDate"
                className='filters_date'
                value={filters.endDate}
                onChange={handleDateChange}
              />
            </div>
          </>
        )}

        {filterMessage && <div className="filter-message">{filterMessage}</div>}

        {(filterType === 'patient' || filterType === 'professional' || filterType === 'date') && (
          <div className="filterButtons">
            <button
              type="button"
              className="sendRadioBtn"
              onClick={applyFilters}
              disabled={loadingAnthropometry || filterType === 'all'}
            >
              {loadingAnthropometry ? 'Buscando...' : 'Aplicar Filtros'}
            </button>
          </div>
        )}
      </div>

      {/* Results section */}
      <div className="getAccordion">
        {loadingAnthropometry ? (
          <div>Carregando medições...</div>
        ) : errorAnthropometry ? (
          <div className="error-message">Erro ao carregar medições antropométricas: {errorAnthropometry}</div>
        ) : currentAnthropometry.length === 0 ? (
          <div>Nenhuma medição encontrada com os filtros selecionados.</div>
        ) : (
          <div>
            {/* <h3 className='anthropometryTitle'>Resultados da Busca ({currentAnthropometry.length} registros)</h3> */}
            <h5 className='anthropometryTitle'>Resultados da Busca</h5>
            <div className="row-getMeasures">
              {currentItems.map((anthropometry, index) => {
                const patient = persons.find(p => p.person_id === anthropometry.patient_id, index = anthropometry.anthropometry_id);
                return (
                  <AnthropometryDetails
                    anthropometry={anthropometry}
                    patientName={findPatientName(anthropometry.patient_id)}
                    patientGender={patient?.gender}
                    patientBirthDate={patient?.birth_date}
                    findNutritionistName={findNutritionistName}
                    formatDate={formatDate}
                    formatGender={formatGender}
                    calculateAge={calculateAge}
                    formatPhysicalActivityLevel={formatPhysicalActivityLevel}
                    formatPhysicalActivityFrequency={formatPhysicalActivityFrequency}
                    formatedClassificatoinBlackburn={formatedClassificatoinBlackburn}
                    formatedClassificationBMI={formatedClassificationBMI}
                    formatedClassificationBray={formatedClassificationBray}
                    formatedClassificationBernadinelli={formatedClassificationBernadinelli}
                    formatedClassificationMuscleMass={formatedClassificationMuscleMass}
                    formatedClassificationLeanMass={formatedClassificationLeanMass}
                    formatedClassificationInternalFat={formatedClassificationInternalFat}
                    formatedClassificationLeanWeightType={formatedClassificationLeanWeightType}
                    formatedClassificationWaistCircumference={formatedClassificationWaistCircumference}
                  />
                );
              })}
            </div>
          </div>
        )}


        {currentItems.length > 0 && (
          <Pagination
            totalItems={searchText ? filteredData.length : currentAnthropometry.length}
            itemsPerPage={itemsPerPage}
            currentPage={currentPage}
            paginate={paginate}
          />
        )}
      </div>
    </>
  );
}

export default GetAnthropometryWithFilters;